import React, {createContext, useContext, useEffect, useState} from 'react';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {useAuthUser} from '../../@crema/utility/AuthHooks';

export type Symbol = {
  id: string;
  name: string;
};

type SymbolContextType = {
  symbols: Symbol[];
  loading: boolean;
};

interface SymbolActionsContextType {
  create: Function;
  remove: Function;
}

const defaultSymbolContext = {
  symbols: [],
  loading: false,
};

const SymbolContext = createContext<SymbolContextType>(defaultSymbolContext);

const SymbolActionsContext = createContext<SymbolActionsContextType>({
  create: () => {},
  remove: () => {},
});

export const useSymbolContext = () => useContext(SymbolContext);
export const useSymbolActionsContext = () => useContext(SymbolActionsContext);

const SymbolProvider = ({children}: any) => {
  const {user} = useAuthUser();
  const [symbols, setSymbols] = useState(defaultSymbolContext.symbols);
  const [loading, setLoading] = useState(defaultSymbolContext.loading);

  useEffect(() => {
    fetchSymbols();
  }, []);

  const fetchSymbols = () => {
    setLoading(true);
    getSymbols().then(({data}) => {
      setSymbols(data.data);
      setLoading(false);
    });
  };

  const create = (name: string) => {
    setLoading(true);
    createSymbol(name).then(() => {
      getSymbols().then(({data}) => {
        setSymbols(data.data);
        setLoading(false);
      });
    });
  };

  const remove = (id: string) => {
    setLoading(true);
    deleteSymbol(id).then(() => {
      getSymbols().then(({data}) => {
        setSymbols(data.data);
        setLoading(false);
      });
    });
  };

  const getSymbols = async () => {
    return jwtAxios.get(`/symbol/get-all/${user.id}`);
  };

  const createSymbol = async (name: string) => {
    return jwtAxios.post(`/symbol/create/${user.id}`, {
      name,
    });
  };

  const deleteSymbol = async (id: string) => {
    return jwtAxios.delete(`/symbol/remove/${id}`);
  };

  return (
    <SymbolContext.Provider value={{symbols, loading}}>
      <SymbolActionsContext.Provider value={{create, remove}}>
        {children}
      </SymbolActionsContext.Provider>
    </SymbolContext.Provider>
  );
};

export default SymbolProvider;
